<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout wrap>
      <v-flex xs8>
        <v-card class="mb-3 pa-2">
          <v-flex xs6>
            <v-card-title primary-title class="px-0 pt-0">
              <div>
                <h3 class="headline mb-2 pl-2">
                  New User
                </h3>
              </div>
            </v-card-title>
            <v-card-actions>
              <v-layout column>
                <v-radio-group row v-model="windowsUser">
                  <v-radio
                    color="success"
                    label="Windows User"
                    v-bind:value="true"
                  ></v-radio>
                  <v-radio
                    color="success"
                    label="Regular User"
                    v-bind:value="false"
                  ></v-radio>
                </v-radio-group>
                <div v-if="windowsUser">
                  <v-autocomplete
                    class="mb-3"
                    hide-details
                    label="User Name"
                    hide-no-data
                    ref="windowsUserName"
                    v-model="user.windowsUser"
                    item-text="displayName"
                    :items="users"
                    :search-input.sync="loadUsers"
                    return-object
                    :rules="[rules.required]"
                  ></v-autocomplete>
                  <v-text-field
                    label="Name"
                    v-model="user.name"
                    ref="windowsName"
                  ></v-text-field>
                  <v-text-field
                    label="Email"
                    v-model="user.email"
                    ref="windowsEmail"
                    :rules="[rules.required, rules.email]"
                  >
                  </v-text-field>
                  <v-text-field
                    class="mb-4"
                    label="UTA Phone"
                    v-model="user.utaPhone"
                    ref="windowsUtaPhone"
                    :rules="[rules.phone]"
                    hint="Used to forward calls to this phone."
                    persistent-hint
                  >
                  </v-text-field>
                  <v-text-field
                    label="Phone Number"
                    v-model="user.phoneNumber"
                    ref="windowsPhoneNumber"
                    :rules="[rules.phone]"
                  >
                  </v-text-field>
                </div>
                <div v-else>
                  <v-text-field
                    label="User Name"
                    v-model="user.username"
                    ref="username"
                    :rules="[rules.required]"
                  ></v-text-field>
                  <v-text-field
                    label="Name"
                    v-model="user.name"
                    ref="name"
                  ></v-text-field>
                  <v-text-field
                    label="Password"
                    type="password"
                    v-model="user.password"
                    ref="password"
                    :rules="[rules.required]"
                  >
                  </v-text-field>
                  <v-text-field
                    label="Email"
                    v-model="user.email"
                    ref="email"
                    :rules="[rules.email]"
                  >
                  </v-text-field>
                  <v-text-field
                    class="mb-4"
                    label="UTA Phone"
                    v-model="user.utaPhone"
                    ref="utaPhone"
                    :rules="[rules.phone]"
                    hint="Used to forward calls to this phone."
                    persistent-hint
                  >
                  </v-text-field>
                  <v-text-field
                    label="Phone Number"
                    v-model="user.phoneNumber"
                    ref="phoneNumber"
                    :rules="[rules.phone]"
                  >
                  </v-text-field>
                </div>
                <v-select
                  class="mb-3"
                  hide-details
                  multiple
                  label="Role"
                  chips
                  item-text="name"
                  v-model="user.roles"
                  :items="roles"
                ></v-select>
                <v-select
                  label="Branch"
                  v-model="user.branch"
                  :items="branches"
                  multiple
                >
                </v-select>
              </v-layout>
            </v-card-actions>
          </v-flex>
          <v-flex xs12>
            <v-card-actions class="mr-0">
              <v-spacer></v-spacer>
              <v-btn dark color="default" class="mr-1" @click="cancel"
                >Cancel</v-btn
              >
              <v-btn :loading="processing" color="success" @click="save"
                >Save User</v-btn
              >
            </v-card-actions>
          </v-flex>
        </v-card>

        <!-- <v-card class="mb-2 pa-2">
                    <v-flex xs4>
                        <v-card-title primary-title class="px-0 pt-0">
                            <div>
                                <h3 class="headline pl-2 mb-2">
                                    Roles
                                </h3>
                            </div>
                        </v-card-title>
                        <v-card-actions>
                            <v-layout column>
                                <div class="font-weight-regular mb-3">
                                    New Role
                                </div>
                                <v-text-field
                                    class="mb-3"
                                    label="Name"
                                    v-model="role.name"
                                ></v-text-field>
                                <v-select
                                    class="mb-5"
                                    hide-details
                                    multiple
                                    label="Permissions"
                                    chips
                                    v-model="role.permissions"
                                    :items="paths"
                                ></v-select>
                                <v-btn color="success">Save Role</v-btn>
                            </v-layout>
                        </v-card-actions>
                    </v-flex>
                </v-card> -->
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import moment from "moment";

export default {
  data: () => ({
    paths: [],
    users: [],
    roles: [],
    branches: [],

    loadUsers: null,
    windowsUser: true,

    processing: false,

    rules: {
      required: (value) => !!value || "Required.",
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return !value || pattern.test(value) || "Invalid e-mail.";
      },
      phone: (v) => {
        const digits = (v ? v : "").replace(/\D/g, "");
        return (
          !(v ? v.trim() : v) ||
          digits.length === 10 ||
          (digits.length === 11 && digits.startsWith("1")) ||
          "Use 10 digits or 11 digits starting with 1."
        );
      },
    },

    user: {
      name: "",
      username: "",
      password: "",
      windowsUser: "",
      password: "",
      email: "",
      utaPhone: "",
      phoneNumber: "",
      branch: "",
      roles: [],
    },
    role: {
      name: "",
      permissions: [],
    },
  }),
  watch: {
    async loadUsers(value) {
      if (!value) return;

      const response = await this.$http.get(
        "api/login/GetADUsers?search=" + value
      );

      this.users = response.map((user) => {
        user.adDisplayName = user.displayName;
        user.displayName = user.displayName + " - " + user.userPrincipalName;

        return user;
      });
    },
    "user.windowsUser"(value) {
      if (!this.windowsUser || !value) {
        if (this.windowsUser) {
          this.user.name = "";
        }
        this.user.email = "";
        return;
      }

      const principalName = value.userPrincipalName ? value.userPrincipalName : "";
      this.user.name = value.adDisplayName ? value.adDisplayName : "";
      this.user.email = principalName.trim();
    },
  },
  created() {
    this.loadRoles();
    this.loadBranches();
  },
  computed: {},
  methods: {
    normalizePhone(value) {
      const digits = (value ? value : "").replace(/\D/g, "");

      if (!digits) return "";
      if (digits.length === 10) return "1" + digits;
      if (digits.length === 11 && digits.startsWith("1")) return digits;

      return "";
    },
    async loadRoles() {
      const response = await this.$http.get("odata/roles");

      this.roles = response.value.sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
    },
    async loadBranches() {
      const branches = await this.$http.get("api/students/getBranchList");

      this.branches = branches.filter(Boolean).sort();
    },
    validate() {
      if (this.windowsUser) {
        return [
          this.$refs.windowsUserName.validate(true),
          this.$refs.windowsEmail.validate(true),
          this.$refs.windowsUtaPhone.validate(true),
          this.$refs.windowsPhoneNumber.validate(true),
        ].every(Boolean);
      }

      return [
        this.$refs.username.validate(true),
        this.$refs.password.validate(true),
        this.$refs.email.validate(true),
        this.$refs.utaPhone.validate(true),
        this.$refs.phoneNumber.validate(true),
      ].every(Boolean);
    },
    buildUserModel() {
      return {
        name: this.user.name ? this.user.name.trim() : "",
        email: this.user.email ? this.user.email.trim() : "",
        username: this.windowsUser
          ? this.user.windowsUser.userPrincipalName
          : this.user.username,
        branch: this.user.branch ? this.user.branch.join(",") : "",
        password: this.windowsUser ? "123456789" : this.user.password,
        isWindowsUser: this.windowsUser,
        phoneNumber: this.normalizePhone(this.user.phoneNumber),
        utaPhone: this.normalizePhone(this.user.utaPhone),
        roles: this.user.roles,
        createdBy: this.$store.state.authentication.user,
      };
    },
    async save() {
      if (!this.validate()) return;

      this.processing = true;

      try {
        await this.$http.post("api/login/createUser", this.buildUserModel());

        this.$router.push({
          name: "Users",
        });
      } catch (e) {
      } finally {
        this.processing = false;
      }
    },
    cancel() {
      this.$router.push({
        name: "Users",
      });
    },
  },
};
</script>
